import { render, staticRenderFns } from "./EditAuth.vue?vue&type=template&id=5fac0b2d&"
import script from "./EditAuth.vue?vue&type=script&lang=js&"
export * from "./EditAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports